export const FETCH_LANDING_PAGE = "fetchLandingPage";
